<template>
  <div ref="whole_page">
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="$siteTypeId() != 1">
      <vx-card v-if="!loadingView" title="Outcomes and Unit standards" class="mb-4">
        <div class="vx-row vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
          
          <div v-if="outcome" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Outcome</h4>
            <table >
              <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{outcome.name}}</p></td></tr>
              <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{outcome.description}}</p></td></tr>
            </table>
          </div>
          <div v-else>
            <h4>Outcome</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
          
          <div  v-if="standard" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Unit Standard</h4>
              <table>
                <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{standard.name}}</p></td></tr>
                <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{standard.description}}</p></td></tr>
              </table>
          </div>
          <div v-else>
            <h4>Unit Standard</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
        </div>
      </vx-card>
    </div>
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
    
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :studentName="taskResults.fullname" :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'LikertScale'">
          <likert-scale-question   :isCardActive="likertScaleQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :studentName="taskResults.fullname" :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :quizInfo="taskResults" :newScore="quizAchievedMarks" :actualTotal="quizTotalMarks" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question :isCardActive="tableQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop  :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- Upload -->
          <upload-question :isCardActive="uploadQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view :isCardActive="uploadTaskView" :uploadTask="taskResults" />
    </div>
    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view :isCardActive="captureTaskView" :captureTask="taskResults" />
    </div>
    <div>
      <snapshot-view :isCardActive="snapshotView && !(loadingView || errorLoadingView) && !(taskResults.uploadTaskId || taskResults.videoCaptureTaskId)" />
      <ispring-final-comment-view v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId" :isCardActive="ispringFinalCommentView && !(loadingView || errorLoadingView)" :totalScore="ispringTotalScore" :quizData="taskResults" :predefinedComments="predefinedComments" />
      <quiz-final-comment-view v-else-if="taskResults && taskResults.quizId" :isCardActive="quizFinalCommentView && !(loadingView || errorLoadingView)" :quizAchievedMarks="quizAchievedMarks" :quizInfo="taskResults" :quizTextTotal="quizTotalMarks" :predefinedComments="predefinedComments" :newQuizTotal="quizTotalMarks" />
      <upload-comment-view v-else-if="taskResults && taskResults.uploadTaskId" :isCardActive="uploadCommentView && !(loadingView || errorLoadingView)" :uploadTask="taskResults" :predefinedComments="predefinedComments" />
      <capture-comment-view v-else-if="taskResults && taskResults.videoCaptureTaskId" :isCardActive="captureCommentView && !(loadingView || errorLoadingView)" :captureTask="taskResults" :predefinedComments="predefinedComments" />
    </div>

    <div v-if="taskResults.length != 0" class="vx-row">
      <vs-spacer></vs-spacer>
      <div id="buttons-container" class="vx-col">
        <vs-button v-if="canQueryAssessment(taskResults.statusId)" color="danger" class="mr-3 vs-con-loading__container" ref="queryAssessmentButton" @click="queryAssessment">Query Assessment</vs-button>
        <vs-button color="success" class="mr-3 vs-con-loading__container" ref="acceptAssessmentButton" @click="acceptAssessment">Accept Assessment</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeTab">Cancel</vs-button>      </div>
    </div>
  </div>
</template>

<script>
import ispringQuizInfoView from "./moderationviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "./moderationviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "./moderationviews/MultipleResponseQuestion.vue";
import textQuestion from "./moderationviews/TextQuestion.vue";
import sequenceQuestion from "./moderationviews/SequenceQuestion.vue";
import matchingQuestion from "./moderationviews/MatchingQuestion.vue";
import sentenceQuestion from "./moderationviews/SentenceQuestion.vue";
import likertScaleQuestion from "./moderationviews/LikertScaleQuestion.vue";
import quizInfoView from "./moderationviews/QuizInfoView.vue";
import mcssQuestion from "./moderationviews/MCSSQuestion.vue";
import mcmsQuestion from "./moderationviews/MCMSQuestion.vue";
import dragAndDropQuestion from "./moderationviews/DragAndDrop.vue";
import freeTextQuestion from "./moderationviews/FreeTextQuestion.vue";
import uploadQuestion from "./moderationviews/UploadQuestion.vue";
import tableQuestion from "./moderationviews/TableQuestion.vue";
import uploadTaskView from "../assessor/assessmentviews/UploadTaskView.vue";
import captureTaskView from "../assessor/assessmentviews/CaptureTaskView.vue";
import snapshotView from "../assessor/assessmentviews/SnapshotsView.vue";
import loadingView from "../assessor/assessmentviews/ResultsLoadingView.vue";
import errorLoadingView from "../assessor/assessmentviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "./moderationviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "./moderationviews/QuizFinalCommentView.vue";
import uploadCommentView from "./moderationviews/UploadCommentView.vue";
import captureCommentView from "./moderationviews/CaptureCommentView.vue";

export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    likertScaleQuestion,
    quizInfoView,
    mcssQuestion,
    mcmsQuestion,
    freeTextQuestion,
    tableQuestion,
    uploadTaskView,
    captureTaskView,
    snapshotView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView,
    uploadQuestion,
    dragAndDropQuestion
  },
  data() {
    return {
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      likertScaleQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      dragAndDropQuestion: true,
      uploadQuestion:true,
      tableQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      predefinedComments: [],
      outcome:[],
      standard:[],
      latestAssessorReportId: null,
      reviewQuestions:[],
      reviewHTML:"",
      lastIndex:0,
      
    };
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;
        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      if(window.opener){
        var btn = window.opener.document.getElementById("refreshTaskListForStudent");
        if (btn) {
          btn.click();
        }
      }

      window.open("", "_self").close();
    },
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadPredefinedComments(){
      const self = this;

      var onSuccess = function (response) {
        self.predefinedComments = response.data.map((item) => {return {label: item.text, value: item.value} });
      };

      self.$ajaxGet(self, "PredefinedComment/GetSelectList", onSuccess);
    },
    loadTask() {
      const self = this;
      self.loadingView = true;

      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };

      self.$ajaxGet(self, "moderator/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    acceptAssessment() {
      var self = this;
      self.showLoadingOnElement("acceptAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.acceptAssessmentButton.$el);
        self.checkIfAllSummativeTaskAssessed();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalModeratorComment = self.taskResults.finalModeratorComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/AcceptedByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalModeratorComment = self.taskResults.finalModeratorComment;

        self.$ajaxPost(self, "QuizAssessment/AcceptedByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.moderatorComment = self.taskResults.moderatorComment;

        self.$ajaxPost(self, "UploadAssessment/AcceptedByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.moderatorComment = self.taskResults.moderatorComment;

        self.$ajaxPost(self, "CaptureAssessment/AcceptedByModerator", assessmentResult, onSuccess);
      }
    },
    queryAssessment() {
      var self = this;
      self.showLoadingOnElement("queryAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.queryAssessmentButton.$el);
        self.closeTab();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalModeratorComment = self.taskResults.finalModeratorComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/QueryByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalModeratorComment = self.taskResults.finalModeratorComment;

        self.$ajaxPost(self, "QuizAssessment/QueryByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.moderatorComment = self.taskResults.moderatorComment;

        self.$ajaxPost(self, "UploadAssessment/QueryByModerator", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.moderatorComment = self.taskResults.moderatorComment;

        self.$ajaxPost(self, "CaptureAssessment/QueryByModerator", assessmentResult, onSuccess);
      }
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    canQueryAssessment(statusId){
      if(statusId === 19)
        return false;

      return true;
    },
    getStandardsAndOutcomes(){
      var self = this;
      var onSuccess = response =>{
        self.standard = response.data.standard;
        self.outcome = response.data.outcome;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_Page){
        }
      }
      //self.$route.query.TaskLogId
      self.$ajaxGet(self, "Course/GetOutcomeInfo/" + self.$route.query.TaskLogId , onSuccess, onFinally);
    },
    checkIfAllSummativeTaskAssessed(){
      var self = this;
      var onSuccess = response => {
        if(response.data.studentModuleStatus == 13){
          self.latestAssessorReportId = response.data.latestAssessorReport;
          self.getReviewQuestions(response.data.latestAssessorReport);
        }
        else
          self.closeTab();
      }
      
      self.$ajaxGet(self, `Moderator/StudentModule/GetStudentModuleStatusIdWithTaskLogId?taskLogId=${self.$route.query.TaskLogId}`, onSuccess);
    },
    getReviewQuestions(latestAssessorReportId){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.reviewQuestions = response.data;
        self.varcReviewHtml();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `moderator/ReviewQuestions?documentId=${latestAssessorReportId}` , onSuccess, onFinally);
    },
    varcReviewHtml(){
      var self = this;
      self.reviewHTML = "";
      for (let index = 0; index < self.reviewQuestions.length; index++) {
        self.reviewHTML += `
        <div class="Heading mb-3">
          <p><span>${self.reviewQuestions[index].questionId}. </span>${self.reviewQuestions[index].question}</p>
        </div>
        <div class="vx-row checkbox-relative">
          <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
            <input type="checkbox" class="check_container" checked id="varcccheck${self.reviewQuestions[index].questionId}">
            <div class="state p-success">
              <label for="varcccheck${self.reviewQuestions[index].questionId}"> Agree</label><br>
            </div>
          </div>
          <div class="vx-col w-2/3">
            <div class="vs-component vs-con-textarea vs-textarea-primary">
              <textarea placeholder="Description" id="varcccomment${self.reviewQuestions[index].questionId}" class="vs-textarea">${self.reviewQuestions[index].moderatorComment ? self.reviewQuestions[index].moderatorComment : ''}</textarea> 
            </div>
          </div>
        </div>
        `;
        self.lastIndex = index;
      };
      self.showpopupReview();
    },
    showpopupReview(){
      var self = this;
      self.$swal({
        title: 'Review of the Assessment',
        icon: 'info',
        html: `
        <h4>Answer the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.reviewHTML}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown varccs-evaluation',
        },
        confirmButtonText:'Complete',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 0; index < self.reviewQuestions.length ; index++) {
            var generatedCheckId = `varcccheck${self.reviewQuestions[index].questionId}`
            var generatedCommentId = `varcccomment${self.reviewQuestions[index].questionId}`
            var check = document.getElementById(generatedCheckId).checked;
            var comment = document.getElementById(generatedCommentId).value;
            self.reviewQuestions[index].moderatorResponse = check;
            self.reviewQuestions[index].moderatorComment = comment;
          }
        },
      }).then((result) => {
        self.returnReview();
      });
    },
    returnReview(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Signed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        self.close();
      }
    
      self.$ajaxPost(self, `moderator/UpdateReviewAnswers?documentId=${self.latestAssessorReportId}`, self.reviewQuestions , onSuccess, onFinally);
    },
  },
  mounted() {
    var self = this;
    self.loadTask();
    self.loadPredefinedComments();
    self.getStandardsAndOutcomes();
    self.isMounted = true;
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 644px) {
  #buttons-container {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}
.AssessorPopUp{
  margin: auto;
  width: fit-content;
  .Review-Dimensions-free{
    width: 100%;
  }
}
.assessment-Questions{
  width: fit-content !important;
  .popupCustomContent{
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
.checkbox-relative{
  .pretty .state label{
    position: relative !important;
  }
}

.varccs-evaluation{
  width: 50% !important;
  .popupCustomContent{
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
</style>
